import { Column as CdsColumn, Grid as CdsGrid } from "@carbon/react";

import { BalanceWithLedgerDisplay } from "./BalanceWithLedgerDisplay";

export const View = (
  {
    title,
    // subtitle,
    navigateButton,
    data,
    total,
    className = "",
  } /*: IBalancesTableProps*/
) => {
  return (
    // <CdsColumn className={`balance--container ${navigateButton ? "with-nav-button" : ""} red-border--show`}>
    <CdsColumn className={`balance--container`}>
      <div
        className={`flex-container header-container align-items--bottom ${
          navigateButton ? "with-nav-button" : ""
        }`}
      >
        <h5 className="flex-box header--title">{title}</h5>

        {navigateButton && navigateButton}
      </div>

      <CdsGrid className="grid">
        {data.map((item) => (
          <CdsColumn sm={4} md={8} lg={16} className="mb-5">
            <BalanceWithLedgerDisplay key={item.reactKey} data={item} />
          </CdsColumn>
        ))}

        {data.length > 0 ? null : (
          <CdsColumn sm={4} md={8} lg={16}>
            <div className="flex-container">
              <small className="flex-box color-light">
                No data to display...
              </small>
            </div>
          </CdsColumn>
        )}
      </CdsGrid>

      <div className="total font-ctm--semibold">
        <BalanceWithLedgerDisplay data={total} />
      </div>
    </CdsColumn>
  );
};
